var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-px-8 tw-py-2"},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.row.accounts || [],"size":"small","no-data-text":_vm.$t('bankProfile.noAccounts')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }